<template>
    <div>
        <slot name="projects">404 No Projects Found</slot>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    
</style>